import {wdiCore, WdiModalAppProps} from "@/components/WdiControls";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {WdiSelect, WdiSelectFormat} from "@/components/WdiControls/WdiSelect";
import {formatter, request, ResponseStatus} from "@/utils/request";
import {Staff} from "@/services/basic/staff";
import {useEffect, useRef, useState} from "react";
import {ProFormInstance} from "@ant-design/pro-form";
import {Form, Input, message} from "antd";
import {ProcessInstance} from "@/services/flow";
import {FormApi} from "@/services/sales";

export const TransferNodeModalApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [form, setForm] = useState<API.Form>();
  const [flowUsers, setFlowUsers] = useState<API.Staff[]>([]);
  const [currentUser,setCurrentUser] = useState<API.Staff>();
  //是否有流程干预权限
  const [allowInterveneFlow,setAllowInterveneFlow] = useState<boolean>(false);


  useEffect(()=>{
    Staff.current().then(res=>{
      setCurrentUser(res?.data)
    })
    FormApi.allowInterveneFlow(props.data?.form?.formId).then(res=>{
      setAllowInterveneFlow(res?.data ?? false);
    })
  },[])

  useEffect(() => {
    if (!form?.processId || !currentUser) {
      setFlowUsers([]);
      return;
    }
    ProcessInstance.getFlowUsers(form.processId).then(res => {
      const users = res?.data;
      if (!users || users.length == 0) {
        setFlowUsers([])
        return;
      }
      Staff.search({staffIds: res?.data.map(item => item.staffId).join(",")}).then(res => {
        setFlowUsers(res?.data ?? [])
      })
      //如果当前用户在当前审批人中 设置指定审批人为当前用户
      if(users.filter(item=>item.staffId==currentUser.staffId).length>0){
        formRef.current?.setFieldsValue({
          targetUserId: {
            value: currentUser.staffId,
            label: wdiCore.String.GenerateLabelDescription(currentUser.staffNoOrName,currentUser.title)
          }
        })
      }
    })
  }, [form?.processId,currentUser])

  useEffect(() => {
    formRef.current?.setFieldsValue({
      formId: props.data?.form?.formId,
    });
    if (props.data?.form?.formId) {
      FormApi.get(props.data?.form?.formId).then(res => {
        setForm(res?.data)
      })
    }
  }, [props.data]);


  return (
    <WdiModalForm
      formRef={formRef}
      labelCol={{span: 6}}
      wrapperCol={{span: 12}}
      labelAlign='left'
      layout='horizontal'
      title={'流程转交'}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.();
        },
      }}
      onFinish={async (values) => {
        const {targetUserId,sourceUserId, ...entity} = values;
        const {data} = props;
        entity.targetUserId = WdiSelectFormat.getvalue(targetUserId);
        entity.sourceUserId = WdiSelectFormat.getvalue(sourceUserId);
        entity.useCaseId = props.data?.useCaseId;
        if(window.confirm('将要由转交的审批人来审批，当前审批节点如是多个审批人会整体跳过，确定要继续吗？')){
          const response = await request(data.url, formatter({method: 'POST', body: entity}));
          if (response.code == ResponseStatus.SUCCESS) {
            message.success('加签成功');
            props.onSave?.(response);
          } else {
            message.error(response.message);
          }
        }
      }}
    >
      <Form.Item name='formId' label='formId' hidden={true}>
        <Input/>
      </Form.Item>
      <Form.Item name='sourceUserId' label='转交的审批人' rules={[{required: true, message: '转交的审批人不能为空'}]}>
        <WdiSelect
          {...{
            placeholder: '请选择转交的审批人',
            showSearch: true,
            remote: true,
            labelInValue: true,
            // mode: 'multiple',
            dataLoading: async (params) => {
              const response = await Staff.ajaxSearch(Object.assign({
                isActive: true,
              }, params));
              return response.data.map((item) => {
                return {
                  value: item.staffId,
                  label: wdiCore.String.GenerateLabelDescription(item.staffNoOrName, item.title),
                };
              });
            },
          }} />
      </Form.Item>
      <Form.Item
        name='targetUserId' label='指定干预的审批人'
        rules={[{required: true, message: '指定干预的审批人不能为空'}]}
      >
        <WdiSelect
          reloadKey={flowUsers.map(item=>item.staffId).join(",")}
          disabled={!allowInterveneFlow}
          {...{
            placeholder: '请选择指定干预的审批人',
            showSearch: true,
            labelInValue: true,
            // mode: 'multiple',
            dataLoading: async (params) => {
              return flowUsers.map((item) => {
                return {
                  value: item.staffId,
                  label: wdiCore.String.GenerateLabelDescription(item.staffNoOrName, item.title),
                };
              });
            },
          }} />
      </Form.Item>
      <Form.Item name='remark' label='备注'>
        <Input.TextArea style={{resize: 'both'}}/>
      </Form.Item>
    </WdiModalForm>
  );
};
